/* ZUMO fold-android: re-measure the page when an Android foldable (Galaxy Z Fold 7 / 8 / 8 Ultra,
   Pixel Fold) changes POSTURE at the same viewport size - flat <-> half-folded book (two
   side-by-side viewport segments) or tabletop / Flex mode (two stacked segments). The posture
   rules in assets/fold-android.css switch the layout through the viewport-segments /
   device-posture media features, but Chromium fires no window 'resize' for a posture change at
   the same CSS size (only the media queries and navigator.devicePosture report it), so whatever
   measured itself on load or on resize keeps the old geometry: Flickity (product-slider-thumbnails,
   slide-show) keeps its cell positions and its inline adaptiveHeight viewport height (the book-
   posture gallery stays 1109px tall around a 408px image; the tabletop hero keeps an 880px
   viewport over a 422px slide), carousel arrows stay centred for the old card height, and
   ScrollTrigger keeps its old start/end positions (on a touch screen it ignores a resize whose
   width did not change).
   On such a change this file, once per change (the segment query, the posture query and
   navigator.devicePosture all report it, a hinge moving through the fold threshold can report it
   twice; one debounced pass):
   (1) flags every active Flickity, so one whose resize() returns early because it is animating or
       being dragged (vendor.min.js "if ( !this.isActive || this.isAnimating || this.isDragging )
       return;", Flickity #1177 - the hero autoplay hit this about 1 flip in 4) re-measures once
       it settles; the flag and its two listeners are dropped as soon as Flickity's own resize()
       really runs (it emits 'resize' only then), so an idle slider is measured exactly once;
   (2) dispatches the same synthetic window 'resize' the theme already dispatches from header.js /
       collection-tabs.js / map.js / slideshow.js, so Flickity's own debounced listener and the
       theme's resize listeners re-measure (carousel arrows, header offsets, lazysizes sizes);
   (3) refreshes ScrollTrigger after those debounced handlers have settled the heights.
   The Duo handlers stay out of it: slideshow.js ignores untrusted resize events, and
   product-thumbnails.js / image-hotspots.js act only on a width change, which a posture change
   does not make. A posture change that comes with a real width change (rotating a half-folded
   phone) is left to the browser's own trusted resize, which already re-measures everything - no
   second pass.
   Inert elsewhere: returns at once on iOS/iPadOS (every browser there is WebKit and supports
   -webkit-touch-callout: every iPhone incl. the iPhone Duo in all postures, every iPad incl.
   Split View / Stage Manager) and on any browser without the viewport-segments / device-posture
   media features or navigator.devicePosture (Safari on macOS, Firefox); ordinary phones, slab
   tablets, desktop windows and flat foldables report one segment and the 'continuous' posture
   for the whole session, so no change event ever reaches the listeners below. */
(function () {
  'use strict';
  if (!window.matchMedia || (window.CSS && CSS.supports && CSS.supports('-webkit-touch-callout', 'none'))) {
    return;
  }
  var posture = navigator.devicePosture && typeof navigator.devicePosture.addEventListener === 'function' ? navigator.devicePosture : null;
  /* boolean context: true on every screen in a browser that knows the features (1 segment is non-zero, 'continuous' is not 'none'); unknown features are false */
  if (!posture && !window.matchMedia('(horizontal-viewport-segments), (vertical-viewport-segments), (device-posture)').matches) {
    return;
  }
  /* one copy per page: a second include (or another posture-relayout snippet using the same flag) stays inert */
  if (window.__zumoFoldAndroidPosture) {
    return;
  }
  window.__zumoFoldAndroidPosture = true;

  var timer = 0;
  var postureChangedAt = 0;
  var widthChangedAt = -Infinity;
  var knownWidth = document.documentElement.clientWidth;
  var scrollTriggerTimer = 0;

  window.addEventListener('resize', function (event) {
    if (!event.isTrusted) {
      return;
    }
    var width = document.documentElement.clientWidth;
    if (width !== knownWidth) {
      knownWidth = width;
      widthChangedAt = performance.now();
    }
  }, { passive: true });

  function refreshScrollTrigger() {
    if (typeof ScrollTrigger === 'undefined' || typeof ScrollTrigger.refresh !== 'function') {
      return;
    }
    clearTimeout(scrollTriggerTimer);
    /* after the theme's debounced resize handlers (Flickity 150 ms, header.js 100 ms) have settled the heights */
    scrollTriggerTimer = setTimeout(function () {
      ScrollTrigger.refresh();
    }, 300);
  }

  function armFlickities() {
    if (typeof Flickity === 'undefined' || typeof Flickity.data !== 'function') {
      return;
    }
    Array.prototype.forEach.call(document.querySelectorAll('.flickity-enabled'), function (element) {
      var flkty = Flickity.data(element);
      if (!flkty || !flkty.isActive || flkty.zumoFoldAndroidArmed || typeof flkty.on !== 'function' || typeof flkty.off !== 'function') {
        return;
      }
      flkty.zumoFoldAndroidArmed = true;
      /* on()/off() rather than once(): ev-emitter keys once-listeners by their source text */
      var done = function () {
        flkty.off('resize', done);
        flkty.off('settle', replay);
        flkty.zumoFoldAndroidArmed = false;
      };
      var replay = function () {
        done();
        flkty.resize();
        if (typeof element._resizeHandler === 'function') {
          element._resizeHandler();
        }
        refreshScrollTrigger();
      };
      flkty.on('resize', done);
      flkty.on('settle', replay);
    });
  }

  function relayout() {
    timer = 0;
    /* skip only when a real width change came with or after the LAST posture change of the burst:
       the resize steps run just before the media queries are re-evaluated in the same frame, and
       that trusted resize's own debounced handlers (Flickity 150 ms, header.js 100 ms) run after any
       posture change within 50 ms of it. Compared with the last change, not the first, so opening
       from the cover screen (width change + book posture) and flattening 100-250 ms later (same
       size) still gets its pass; otherwise the gallery kept the book-posture width when flat. */
    if (widthChangedAt >= postureChangedAt - 50) {
      return;
    }
    armFlickities();
    window.dispatchEvent(new Event('resize'));
    refreshScrollTrigger();
  }

  function schedule() {
    postureChangedAt = performance.now();
    clearTimeout(timer);
    timer = setTimeout(relayout, 250);
  }

  ['(horizontal-viewport-segments: 2)', '(vertical-viewport-segments: 2)', '(device-posture: folded)'].forEach(function (query) {
    var mql = window.matchMedia(query);
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', schedule);
    }
  });
  if (posture) {
    posture.addEventListener('change', schedule);
  }
})();
